import { render } from "./reportComponent.vue?vue&type=template&id=8fe6bb3e"
import script from "./reportComponent.vue?vue&type=script&lang=js"
export * from "./reportComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__